module.exports = __webpack_public_path__ + "static/animated_shield-7d4f3641297544b5e5358a4819a1c507.jpeg";